import * as Yup from 'yup'

export const NewPasswordProjectManagerSchema = Yup.object().shape({
  new_password: Yup.string()
    .required('New password is required.')
    .min(8, 'New password must be at least 8 characters.')
    .test({
      name: 'passwordComplexity',
      test: (new_password) =>
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&_])[^\s]{8,}$/.test(new_password),
      message:
        'New password must include uppercase, lowercase, a number, and a special character (#@$!%*?&_).',
    }),
  new_password_confirmation: Yup.string()
    .required('Password confirmation is required.')
    .when('new_password', ([new_password], schema) => {
      return schema.test({
        test: (new_password_confirmation) =>
          !!new_password && new_password_confirmation === new_password,
        message: 'Password confirmation must match the new password.',
      })
    }),
})
